export const customTranslations = {
    "mute_all": 'Silenciar a todos',
    "cancel": "Cancelar",
    "settings": "Configuraciones",
    "leave_confirmation": "Salir de la videollamada",
    "setup_screen.joining_as": "Unirse como",
    "disable_mic": "Desactivar micrófono",
    "enable_mic": "Activar micrófono",
    "mic_off": "Micrófono apagado",
    "mic_on": "Micrófono encendido",
    "disable_video": "Desactivar video",
    "enable_video": "Activar video",
    "video_off": "Video desactivado",
    "video_on": "Video activado",
    "connection": "Conexión",
    "join": "Unirse",
    "joined": "Se ha unido",
    "full_screen": "Pantalla completa",
    "full_screen.exit": "Salir de pantalla completa",
    "screenshare.start": "Compartir pantalla",
    "screenshare.stop": "Dejar de compartir",
    "screenshare.shared": "Tu pantalla se esta compartiendo",
    "screenshare.max_preview": "Expandir vista previa",
    "screenshare.min_preview": "Minimizar vista previa",
    "leave": "Salir",
    "dismiss": "Dismiss",
    "more": "Más",
    "pip_on": "Mostrar pip",
    "pip_off": "Esconder pip",
    "chat.new": "Nuevo",
    "chat.new_channel": "Crear nuevo canal",
    "chat.channel_name": "Introducir nombre del canal",
    "chat.member_name": "Introducir nombre del miembro",
    "chat.add_members": "Agregar miembros",
    "chat.delete_msg": "Eliminar",
    "chat.edit_msg": "Editar",
    "chat.send_msg": "Enviar mensaje",
    "chat.send_attachment": "Arrastrar imagenes/archivos para enviar",
    "chat.send_img": "Enviar una imagen",
    "chat.send_file": "Enviar un archivo",
    "chat.send_emoji": "Enviar un emoji",
    "chat.update_msg": "Editar mensaje",
    "chat.channel_members": "Miembros del canal",
    "chat.welcome": "Crea un nuevo canal para empezar",
    "chat.img.loading": "Cargando imagen",
    "chat.error.img_not_found": "Imagen no encontrada",
    "chat.error.empty_results": "No se pudo encontrar un miembro con el nombre especificado",
    "chat.img.shared_by": "Compartido por",
    "participants": "Participantes",
    "participants.errors.empty_results": "No se pudo encontrar un miembro con el nombre especificado",
    "participants.empty_list": "Parece que no hay nadie aquí",
    "participants.turn_off_video": "Desactivar video",
    "polls": "Encuestas",
    "polls.by": "Encuesta por",
    "polls.question": "Pregunta de la encuesta",
    "polls.question.placeholder": "¿Cúal es tu pregunta?",
    "polls.option": "Agregar opción",
    "polls.option.placeholder": "Introduce una opción",
    "polls.results.anon": "Anónima",
    "polls.results.hide": "Ocultar resultados antes de votas",
    "polls.create": "Crear encuesta",
    "polls.cancel": "Cancelar creación de la encuesta",
    "polls.errors.question_required": "Pregunta es requerida",
    "polls.errors.empty_option": "Opciones en blanco no son permitidas",
    "perm_denied": "Permiso denegado por el navegador",
    "ended.left": "Inicializando la videollamada..."
}

